import {
    SESSION_DESCRIPTION_MAX_LENGTH,
    SESSION_DESCRIPTION_MIN_LENGTH,
} from "../Repositories/SessionDescriptionRepository";

/**
 * Déroulement des séances propre à un cours (étape 1 de la déclaration) :
 * surcharge facultative de la description générique du professeur.
 */

/** Message d'erreur de la surcharge, ou chaîne vide. Vide = pas de surcharge, jamais une erreur. */
export const sessionDescriptionOverrideError = (value: string | null | undefined): string => {
    const trimmed = (value ?? "").trim();
    if (trimmed === "") return "";
    if (trimmed.length < SESSION_DESCRIPTION_MIN_LENGTH) {
        return `La description de ce cours doit contenir au moins ${SESSION_DESCRIPTION_MIN_LENGTH} caractères, ou rester vide pour reprendre votre description habituelle.`;
    }
    if (trimmed.length > SESSION_DESCRIPTION_MAX_LENGTH) {
        return `La description de ce cours ne peut pas dépasser ${SESSION_DESCRIPTION_MAX_LENGTH} caractères.`;
    }
    return "";
};

/**
 * Valeur envoyée au serveur : null quand la surcharge est vide ou identique à
 * la description habituelle (inutile de figer une copie sur le cours).
 */
export const normalizeSessionDescriptionOverride = (
    value: string | null | undefined,
    generic: string | null | undefined
): string | null => {
    const trimmed = (value ?? "").trim();
    if (trimmed === "") return null;
    if ((generic ?? "").trim() === trimmed) return null;
    return trimmed;
};
